const ThreeDotsHorizontal = ({ className="", onClick=null, ...rest }) => {
  return (
    <svg className={className} onClick={onClick} {...rest} width="25" height="4" viewBox="0 0 19 4"  xmlns="http://www.w3.org/2000/svg">
      <circle cx="16.2561" cy="2.0002" r="2.0002" />
      <circle cx="9.0002" cy="2.0002" r="2.0002" />
      <circle cx="2.0002" cy="2.0002" r="2.0002" />
    </svg>

  );
};

export default ThreeDotsHorizontal;